import React from 'react';
import { Reveal } from './Reveal';
const items = [{
  number: '01',
  title: 'Flexibilidad',
  text: 'Conoce una alternativa que puedes desarrollar de acuerdo con tu disponibilidad y objetivos.'
}, {
  number: '02',
  title: 'Capacitación',
  text: 'Aprende sobre la industria y prepárate para completar los requisitos y licencias correspondientes.'
}, {
  number: '03',
  title: 'Acompañamiento',
  text: 'Existe un proceso de capacitación y apoyo para ayudarte a conocer cómo funciona la industria.'
}, {
  number: '04',
  title: 'Desarrollo',
  text: 'Desarrolla conocimientos, habilidades comerciales y experiencia dentro de la industria financiera.'
}];
export function Benefits() {
  return <section className="w-full bg-ink-700 py-24 sm:py-32 lg:py-40" aria-labelledby="benefits-title" data-id="element-17" data-mp="3ctpc8gtq78e1">
      <div className="mx-auto max-w-page px-5 sm:px-10 lg:px-12" data-id="element-18" data-mp="1fx8drwxqrqem">
        <Reveal data-id="element-19" data-mp="1b114pva1tysg">
          <h2 id="benefits-title" className="max-w-2xl font-sans text-[1.85rem] font-light uppercase leading-[1.12] text-ivory sm:text-4xl xl:text-[3rem]" data-id="element-20" data-mp="1ayez416pxtcv">
            ¿Qué puedes encontrar
            <br className="hidden sm:block" data-id="element-21" data-mp="3oyo0s8yg3he1" /> en este camino?
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-x-20 border-t border-ivory/12 sm:mt-16 md:grid-cols-2" data-id="element-22" data-mp="3txhhea913oif">
          {items.map((item, i) => <Reveal key={item.number} delay={Math.min(i * 0.07, 0.25)} className="border-b border-ivory/12" data-id="element-23" data-mp="lj0ftldi8ckc" data-mpi={i}>
              <div className="flex gap-6 py-9 sm:gap-10 sm:py-11" data-id="element-24" data-mp="bs5qg84yowuo">
                <span className="font-serif text-2xl leading-none text-champagne sm:text-3xl" data-id="element-25" data-mp="bprzaadek4se">
                  {item.number}
                </span>
                <div data-id="element-26" data-mp="14g9y2z73fk00">
                  <h3 className="font-sans text-sm font-medium uppercase tracking-[0.2em] text-ivory" data-id="element-27" data-mp="14eyxt9cuwudn">
                    {item.title}
                  </h3>
                  <p className="mt-3 max-w-sm font-sans text-base font-light leading-relaxed text-steel-200 sm:text-[17px]" data-id="element-28" data-mp="1j3s8me7c78uc">
                    {item.text}
                  </p>
                </div>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}